
import { serverApi } from '../../core';

import { Log } from '../../core';
let log = Log.getLogger('MultiSceneForApp.search.server.search');

function doSearch(projectId, queryId, searchData, clientOptions, debug, callback) {
    if (searchData.params) {
        doSearchGet(projectId, queryId, searchData, clientOptions, debug, callback);
    } else {
        doSearchPost(projectId, queryId, searchData, clientOptions, debug, callback);
    }
}

function doSearchGet(projectId, queryId, searchData, clientOptions, debug, callback) {
    let clientDesc = clientOptions ? clientOptions.desc : '';
    serverApi.callFunctionGet(
        'search', null, 'doSearch',
        [
            ['project', projectId],
            ['queryId', queryId],
            ...searchData.params.map(item => {
                return [item.id, item.value];
            }),
            ['clientDesc', clientDesc],
            ['debug', debug]
        ],
        serverApi.OUTPUT_TYPE_JSON,
        (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`search.server.search.doSearchGet() failed`);
                }
                callback(
                    err,
                    (response && response.search) ? response.search : null
                );
            }
        }
    );
}

function doSearchPost(projectId, queryId, searchData, clientOptions, debug, callback) {
    let clientDesc = clientOptions ? clientOptions.desc : '';
    serverApi.callPost({
        module: 'search',
        name: 'doSearch',
        body: {
            projectId,
            queryId,
            searchData,
            clientDesc,
            debug
        },
        callback: (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`search.server.search.doSearchPost() failed`);
                }
                callback(
                    err,
                    (response && response.search) ? response.search : null
                );
            }
        }
    });
}

function getDefinition(projectId, debug, callback) {
    serverApi.callFunctionGet(
        'search', null, 'getDefinition',
        [
            ['project', projectId],
            ['debug', debug]
        ],
        serverApi.OUTPUT_TYPE_JSON,
        (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`search.server.search.getDefinition() failed`);
                }
                callback(
                    err,
                    (response && response.searchDefinition) ? response.searchDefinition : null
                );
            }
        }
    );
}

export {
    doSearch,
    getDefinition
};
